export const HEADING = 'Next, tell us about your occupation';
export const SUBHEADING =
  "Disability insurance is about protecting your income, so let's get a picture of how much you currently earn.";
